import { BigNumber } from 'bignumber.js'
import { commify } from 'ethers/lib/utils'
import { TICKERS, TICKERS_MAP_BY_NAME, SupportedTicker, Ticker } from '@/constants/token'

export const ZeroAddress = '0x0000000000000000000000000000000000000000'

export function toSmallAddr(str: string, start = 6, end = 4) {
  if (!str || str.length <= 10) return str
  return `${str?.substr(0, start)}...${str?.substr(str?.length - end, end)}`
}

export const isSupportedTicker = (input: any) => {
  return TICKERS.map((ticker) => ticker.name).includes(input)
}

export const getTokenDecimals = (ticker: SupportedTicker, chainId: number) => {
  return TICKERS_MAP_BY_NAME[ticker].erc20Tokens?.[chainId]?.decimal
}

export const shouldUseValutContract = (ticker: SupportedTicker) => {
  if (ticker === 'USD0' || ticker === 'b2bb') {
    return true
  } else return false
}

export const getTickerByErcAddress = (address: string): Ticker | undefined => {
  return TICKERS.find((ticker) => {
    return Object.values(ticker.erc20Tokens).find((token) => {
      // console.log('>> token.address, address', token.symbol, token.address, address)
      return token.address === address
    })
  })
}

export const formatNumber = (
  input: string,
  unit: number,
  options?: { shouldCommify?: boolean; decimal?: number },
): string => {
  const _shouldCommify = options?.shouldCommify === undefined ? true : options?.shouldCommify
  const _decimal = options?.decimal === undefined ? 2 : options?.decimal

  // console.log('>>> ', input, options?.shouldCommify, _shouldCommify)

  if (_shouldCommify === false) {
    return new BigNumber(input).div(10 ** unit).toFixed(_decimal, BigNumber.ROUND_DOWN)
  } else {
    return commify(new BigNumber(input).div(10 ** unit).toFixed(_decimal, BigNumber.ROUND_DOWN))
  }
}
